import React, { useEffect, useState } from 'react';

import cloverSportLogo from '@/assets/images/clover-sport-logo.png';
import LoadingSpinner from '@/components/LoadingSpinner';
import WelcomePage from '@/components/Welcome';
import { MfaDevices } from '@/features/mfa/components/MfaDevices';
import { getTypeDetails, useMfaDevices } from '@/features/mfa/components/MfaDevicesContainer';
import { selectIsSuperAdmin } from '@/features/user/selectors';
import { getConfigValue } from '@/helpers/configHelper';
import { withSentry } from '@/instrument';

import { Action } from '@bypasslane/clover--web-lib-sprout-action';
import { Card, CardBody } from '@bypasslane/clover--web-lib-sprout-card';
import { Heading } from '@bypasslane/clover--web-lib-sprout-heading';
import { useSelector } from 'react-redux';

import '@/features/login/components/LoginSuccess.css';

const managerUrl = getConfigValue('managerUrl');
const shouldShowMarcus = getConfigValue('showMarcus');

const suggestions = [
  {
    title: 'Manager',
    description: 'Manage admin settings for your venue.',
    href: managerUrl
  }
];

export const LoginSuccess = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const isSuperAdmin = useSelector(selectIsSuperAdmin);
  const { devices: mfaDevices, hasFetchedDevices: devicesLoaded } = useMfaDevices();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-center mb-4">
        <img src={cloverSportLogo} alt="Clover Sport Logo" className="h-8 mt-2" />
      </div>
      <WelcomePage isSuperAdmin={isSuperAdmin && shouldShowMarcus}>
        <>
          <div className="mt-6 w-full max-w-2xl">
            <div className="mb-4 text-left">
              <Heading headingLevel="h6" className="font-semibold">
                Suggestions
              </Heading>
              <p className="text-sm text-gray-700 mb-4">
                Here are some suggestions to get you started:
              </p>
            </div>
            {suggestions.map((suggestion, index) => (
              <Card key={index} className="mb-2">
                <CardBody>
                  <div className="flex items-center justify-between">
                    <div className="flex-1 pr-4 text-left">
                      <Heading headingLevel="h2" className="font-semibold">
                        {suggestion.title}
                      </Heading>
                      <p className="text-sm text-gray-700">{suggestion.description}</p>
                    </div>
                    <div>
                      <Action href={suggestion.href} className="mt-2">
                        Go to {suggestion.title}
                      </Action>
                    </div>
                  </div>
                </CardBody>
              </Card>
            ))}
          </div>
          <hr className="my-1" />

          <div className="mt-6 w-full max-w-2xl text-left px-4">
            <div className="mb-4">
              <Heading headingLevel="h6" className="font-semibold">
                Two-factor authentication
              </Heading>
              <p className="text-sm text-gray-700 mb-4">
                Manage your two-factor authentication devices to enhance your account security.
              </p>
            </div>
            <MfaDevices
              devices={mfaDevices}
              getTypeDetails={getTypeDetails}
              devicesLoaded={devicesLoaded}
              sectionTitle=""
              description=""
              className="text-left mt-4"
            />
          </div>
        </>
      </WelcomePage>
    </div>
  );
};
export default withSentry(LoginSuccess, {
  enableProfiler: true,
  enableErrorBoundary: true
});
LoginSuccess.displayName = 'LoginSuccess';
